import styled from "styled-components";

export const Wrapper = styled.div`
  border-radius: 5px;
  width: 100%;

  .ui.cards {

    .ui.card {

      .content {
        padding: 0;
      }

      .summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem;

        &.available {
          cursor: pointer;
        }

        &.open {
          background-color: #fafafa;
        }

        .heading {
          margin: 0;
        }

        .indicator {
          margin: 0 4px;

          .icon {
            color: #a0acb0;
            transition: transform 300ms ease;

            &.open {
                transform:rotate(-90deg)
            }

          }

        }

        .ui.label {
          border-radius: 11px;
          color: rgba(40, 64, 74, 0.4);
          background: rgba(169, 179, 183, 0.16);

          .icon {
            color: #f29f5c;
            margin: 0;
          }
        }

        .header {
          font-family: Roboto;
          font-size: 17px;
          color: #5b6d74;
          margin: 0;
          line-height: 1.6;
        }

        .progress {
          width: 68px;
          height: 68px;
        }

        .meta {
          font-family: Roboto;
          font-size: 13px;
          color: #a0acb0;
          line-height: 0.92;

          label {
            color: #f29f5c;
          }
        }

      }

      .detail {
        box-sizing: border-box;
        border-top: 1px solid #f3f3f3;
        padding: 0 1.25rem;
        max-height: 0;
        overflow: hidden;
        transition: all 300ms ease;

        &.open {
          max-height: 7500px;
        }

        .columns {
          margin-top: 1rem;
          display: flex;
          justify-content: space-between;
        }

        .spacer {
          min-width: 8px;
        }
      }

    }

  }

`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefDashboard/style.js